//import clientAPI from "@/api/ClientAPIMixin.js";
import i18n from '@/plugins/i18n.js';

const ParentjobEditModel = {
    headerTitle: i18n.t("servicesystem.common_objects.job.job"),
    enabledIcon: "$job",
    disabledIcon: "mdi-briefcase-off",
    listItemTextKey: "DisplayName",

    fields: [
        { type: "input", label: i18n.t("servicesystem.common_objects.job.status"), valuekey: "JobStatus.Name", editable: true, rules: "", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.job.substatus"), valuekey: "JobSubStatus.Name", editable: true, rules: "", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.job.type"), valuekey: "JobType.Name", editable: true, rules: "", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.job.priority"), valuekey: "JobPriority.Name", editable: true, rules: "", defaultValue: "" },
        { type: "date", label: i18n.t("servicesystem.common_objects.job.created"), valuekey: "CreatedDate", editable: true, rules: "", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.job.creator"), valuekey: "CreatedBy", editable: true, rules: "", defaultValue: "" },
        { type: "area", label: i18n.t("servicesystem.common_objects.job.first_line_comment"), valuekey: "FirstLineComment", editable: true, rules: "", defaultValue: "" },
    ],

    methods: {

    }
}

export default ParentjobEditModel;